import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var EyeOffIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M10 5.2c.7-.1 1.4-.2 2-.2 5.4 0 8.9 5.4 9.9 7-.6 1-1.2 1.8-1.8 2.5-.4.4-.3 1 .1 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3.8-.9 1.6-2 2.3-3.4.2-.3.2-.6 0-.9C23.7 11.2 19.5 3 12 3c-.8 0-1.5.1-2.2.2-.6.1-1 .6-.9 1.1.1.6.6 1 1.1.9zM23.7 22.3L10.6 9.2 1.7.3C1.3-.1.7-.1.3.3s-.4 1 0 1.4L4.6 6C2.7 7.6 1.2 9.5.1 11.5c-.1.3-.2.6 0 .9.2.4 4.4 8.6 11.9 8.6 2.1-.1 4.1-.7 5.7-1.8l4.5 4.5c.2.2.5.3.7.3s.5-.1.7-.3c.5-.4.5-1 .1-1.4zM10 11.5l2.5 2.5c-.1 0-.3 0-.5.1-.5 0-1-.2-1.4-.6-.6-.6-.8-1.4-.6-2zm2 7.5c-5.4 0-8.9-5.4-9.9-7 1-1.7 2.3-3.2 3.9-4.5L8.6 10c-1 1.5-.8 3.5.6 4.9.7.7 1.7 1.1 2.7 1.1h.1c.7 0 1.4-.2 2-.6l2.3 2.3c-1.3.8-2.8 1.2-4.3 1.3z"
                    })
                })
            })
        ]
    });
};
EyeOffIcon.isCarinaIcon = true;
export default EyeOffIcon;
